const t = {
  name: "SkipRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5859 11.9999L6.58594 15.9999L8.00015 17.4141L13.4144 11.9999L8.00015 6.58569L6.58594 7.99991L10.5859 11.9999Z" fill="currentColor"/>
<path d="M17 16.9999L17 6.99993L15 6.99993V16.9999H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as SkipRight
};
